module.exports = __webpack_public_path__ + "static/media/nubes.60c3b7f7.svg";